import { ref, getDownloadURL, uploadBytes } from '@firebase/storage'
import { storage } from '@/config/firebase'
import type { VehicleTimelineNoteAttachment } from '@otw/models/timeline'

export async function uploadVehicleTimelineNoteAttachments(
  vehicleId: string,
  files: File[]
): Promise<VehicleTimelineNoteAttachment[]> {
  if (!storage) {
    throw new Error('Firebase Storage is not initialized')
  }
  return Promise.all(
    files.map(async (file, index) => {
      const fileExtension = file.name.split('.').pop() || ''
      const baseFileName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name
      const sanitizedBaseName = baseFileName.replace(/[^a-zA-Z0-9._-]/g, '_').replace(/_{2,}/g, '_')
      const uniqueId = `${Date.now()}-${index}`
      const fileName = `${uniqueId}_${sanitizedBaseName}${fileExtension ? `.${fileExtension}` : ''}`
      const storagePath = `vehicle_timeline/${vehicleId}/note_attachments/${fileName}`
      const storageRef = ref(storage, storagePath)
      const snapshot = await uploadBytes(storageRef, file)
      const download_url = await getDownloadURL(snapshot.ref)
      return {
        storage_path: storagePath,
        download_url,
        file_name: file.name,
        ...(file.type ? { content_type: file.type } : {}),
      }
    })
  )
}
